import {Button, Card, Col, Container, Form, Row, Table} from "react-bootstrap";
import {addJobNotes, getJobNotes} from "../service/JobService";
import {useEffect, useState} from "react";
import {convertDescriptionPrefix, covertJobTitle} from "../service/jobutil";
import JobImageGallary from "./JobImageGallary";


export default function JobExpand(job) {
    const [jobNoteList, setJobNoteList] = useState([])
    const [newJobNote, setNewJobNote] = useState("")
    const [images, setImages] = useState()


    function refreshJobNotesList() {
        getJobNotes(job.data.cos_job_id).then(response => {
            if (response.status === 200) {
                response.json().then(result => {
                    setJobNoteList(result)
                })
            } else {
                // setResponseMessage("Error fetching user details")
            }
        })
            .catch(error => console.log('error', error));
    }

    useEffect(() => {
        refreshJobNotesList();
    }, []);


    function handleAddNewJobNoteSubmit(e) {
        e.preventDefault();
        addJobNotes(job.data.cos_job_id, newJobNote).then(response => {
            if (response.status === 201) {
                setNewJobNote("")
                refreshJobNotesList();

            }
        })

    }

    return (<div>
        <Container fluid>
            <Row>
                <Col sm={6}>
                    <Card style={{textAlign: "left"}}>

                        <Card.Body>
                            <Card.Text>
                                <b>{covertJobTitle(job.data)}</b>
                            </Card.Text>
                            <Card.Text>
                                {convertDescriptionPrefix(job.data)}
                            </Card.Text>
                            <Card.Text>
                                {job.data.description}
                            </Card.Text>
                            <Card.Text>
                                {job.data.email}<br/>
                                {job.data.phone}
                            </Card.Text>
                        </Card.Body>
                    </Card>
                </Col>
                <Col sm={6}>

                    <Table striped bordered hover size="sm">
                        <thead>
                        <tr>
                            <th>Notes</th>
                            <th>Time</th>
                            <th>Created By</th>

                        </tr>
                        </thead>
                        <tbody>
                        {jobNoteList.map((jobnote) => (
                            <tr>
                                <td>{jobnote.note}</td>
                                <td>{new Date(jobnote.timestamp).toLocaleString()}</td>
                                <td>{jobnote.createdby}</td>
                            </tr>
                        ))}
                        </tbody>
                    </Table>
                    <Form onSubmit={handleAddNewJobNoteSubmit}>
                        <Container fluid style={{padding: "0px"}}>
                            <Row>
                                <Col sm={10}><Form.Group className="mb-3" controlId="jobnote" style={{width: "100%"}}>
                                    <Form.Control type="text"
                                                  value={newJobNote}
                                                  required
                                                  onChange={(e) => setNewJobNote(e.target.value)}
                                                  placeholder="Add New Job Note"/>
                                </Form.Group></Col>
                                <Col sm={2}>
                                    <Button variant="secondary" type="submit"
                                            disabled={newJobNote.length <= 0}
                                            style={{width: "100%"}}>
                                        Add
                                    </Button>
                                </Col>
                            </Row>

                        </Container>
                    </Form>


                </Col>
            </Row>
            <Row>
                <JobImageGallary job={job.data}
                                 images={images}
                                 isReadOnly={true}
                                 setImages={setImages}/>

            </Row>

        </Container>


    </div>)

}
